// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"bccfd427","438":"73d77587","756":"d6cb3ba0","953":"203440b5"}[chunkId] + ".chunk.css";
};